"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROGRESS_STEPPER_LABEL_APPEARANCES = void 0;
var PROGRESS_STEPPER_LABEL_APPEARANCES = Object.freeze({
  ALL: 'all',
  CURRENT: 'current',
  NONE: 'none'
});
exports.PROGRESS_STEPPER_LABEL_APPEARANCES = PROGRESS_STEPPER_LABEL_APPEARANCES;